import { createComponent } from 'react-fela'
import { createElement } from 'react'

import calculatePerBreakpoint from '../utils/calculatePerBreakpoint'
import { breakpoints } from '../constants/theme'

const Text = props => ({
  fontSize: props.size,
  lineHeight: `${props.height}px`,
  color: props.color,
  display: props.flex && 'flex',
  fontFamily: props.lora ? 'Lora' : 'Istok Web',
  textAlign: props.textAlign,
  fontWeight: props.bold ? 700 : 400,
  fontStyle: props.italic && 'italic',
  flexDirection: props.row && 'row',
  textDecoration: 'none',
  maxWidth: '100%',
  userSelect: props.noSelect && 'none',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  opacity: props.opacity,
  ':hover': {
    transition: '300ms all ease-in-out',
    color: props.hoverColor
  },
  [`@media (max-width: ${breakpoints.min768 - 1}px)`]: { textAlign: 'center' },
  extend: [
    calculatePerBreakpoint(props.sizes, value => ({ fontSize: value })),
    calculatePerBreakpoint(props.heights, value => ({ lineHeight: `${value}px` })),
    {
      condition: props.ellipsis,
      style: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
      }
    }
  ]
})

const text = ({ tag, children, ...otherProps }) => createElement(tag || 'span', otherProps, children)

export default createComponent(Text, text, [
  'onClick',
  'data-scroll-effect',
  'data-scroll-offset',
  'data-parallax-speed',
  'data-parallax-direction',
  'data-parallax-count',
  'tag'
])



// WEBPACK FOOTER //
// ../components/Text.js